import LayoutPadrao from '../layouts/LayoutPadrao.vue'
import configuracaoVariaveisView from '@/views/configuracao/ConfiguracaoVariaveisView.vue'
import ConfiguracaoAliquotaImpostoView from '@/views/configuracao/ConfiguracaoAliquotaImpostoView.vue'
import PrecosProdutos from '@/views/configuracao/PrecosProdutos.vue'

// Auth check function
const isAuthenticated = (to, from, next) => {
  const isLoggedIn = localStorage.getItem('user') !== null
  if (isLoggedIn) next()
  else next('/login')
}

export default {
  path: '/',
  component: LayoutPadrao,
  beforeEnter: isAuthenticated,
  children: [
    {
      path: 'variaveis',
      name: 'configuracao-variaveis',
      component: configuracaoVariaveisView,
      meta: {
        requiresAuth: true,
        title: 'Variáveis de Configuração',
        nome_fisico: 'config',
      },
    },
    //aliquota-imposto
    {
      path: 'aliquota-imposto',
      name: 'configuracao-aliquota-imposto',
      component: ConfiguracaoAliquotaImpostoView,
      meta: {
        requiresAuth: true,
        title: 'Alíquota do Imposto',
        nome_fisico: 'aliquota-imposto',
      },
    },
    // precos-produtos
    {
      path: 'precos-produtos',
      name: 'configuracao-precos-produtos',
      component: PrecosProdutos,
      meta: {
        requiresAuth: true,
        title: 'Preços dos Produtos',
        nome_fisico: 'precos-produtos',
      },
    },
  ],
}
